// Sidebar del rol Admin Tenant — panel de configuración estable del tenant.

import { Sidebar, SidebarGroup, SidebarItem } from './SidebarNav';

export function AdminSidebar() {
  return (
    <Sidebar>
      <SidebarGroup label="Tenant">
        <SidebarItem to="/admin" end icon="user-cog">
          Configuración
        </SidebarItem>
        <SidebarItem to="/admin/clientes" icon="users">
          Clientes
        </SidebarItem>
      </SidebarGroup>
      <SidebarGroup label="Estructura">
        <SidebarItem to="/admin/estructura" icon="factory">
          Plantas · Áreas · Líneas
        </SidebarItem>
        <SidebarItem to="/admin/causales" icon="alert">
          Causales de paro
        </SidebarItem>
        <SidebarItem to="/admin/integracion" icon="plug">
          Integración de planta
        </SidebarItem>
      </SidebarGroup>
      <SidebarGroup label="Gobierno">
        <SidebarItem to="/admin/usuarios" icon="user-cog">
          Usuarios
        </SidebarItem>
        <SidebarItem to="/admin/auditoria" icon="chart-bar">
          Auditoría
        </SidebarItem>
      </SidebarGroup>
    </Sidebar>
  );
}
